<div #cryptoList id="crypto-list" class="hidden popup-modal fixed right-0 left-0 top-0 dev-height sm:top-4 z-max sm:justify-center items-center sm:inset-0 sm:h-modal">
  <div class="flex min-w-full items-center justify-center min-h-screen sm:pt-4 sm:px-4 sm:pb-20 text-center sm:block sm:p-0">
    <div class="fixed bg-gray-900 bg-opacity-50 dark:bg-opacity-80 inset-0 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="scrollable-content-container main-container dev-height sm:h-auto inline-block align-bottom bg-white popup px-4 sm:pt-5 sm:pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:align-middle sm:max-w-sm sm:w-full sm:p-6">

      <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
        <button (click)="hide()" type="button" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none">
          <span class="sr-only" i18n>Close</span>
          <!-- Heroicon name: outline/x -->
          <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div>
        <div class="text-left">
          <h3 class="leading-6 text-lg font-medium text-gray-900" id="modal-title2" i18n>Coin</h3>
          <div class="mt-2 list-container">

            <div class="pb-1">
              <div class="mt-1 relative rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <!-- Heroicon name: solid/mail -->
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 20 20" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <input #searchinput [(ngModel)]="filter" type="search" name="search" id="search" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" i18n-placeholder="Search">
              </div>
            </div>

            <!-- This example requires Tailwind CSS v2.0+ -->
            <nav class="scrollable-items-container overflow-y-auto h-screen sm:h-full" aria-label="Directory">
              <div class="scrollable-content relative">
                <div *ngIf="filter == '' && exchangePrices.length > 5" class="max-w-sm flex flex-wrap items-center pt-4 pb-2">
                  <!-- highlighted currencies -->
                  <button *ngFor="let crypto of highlightedCryptos"
                          type="button" (click)="selectCrypto(crypto)" class="flex items-center mr-2 mb-2 rounded-md bg-gray-50 px-2.5 py-1.5 text-sm font-semibold text-gray-600 shadow-sm hover:bg-gray-100">
                    <img *ngIf="crypto?.baseCurrency != null" class="w-6 h-6 mr-1" src="/assets/icons/currencies/color/{{crypto.baseCurrency | lowercase}}.svg">{{crypto.baseCurrency}}
                  </button>
                </div>
                <ul role="list" class="relative z-0 divide-y divide-gray-200">
                  <li *ngFor="let crypto of exchangePrices | filtercrypto: filter" class="bg-white">
                    <div class="relative px-0 py-3 flex items-center space-x-3 hover:bg-gray-50 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
                      <div class="flex-shrink-0">
                        <img *ngIf="crypto?.baseCurrency != null" class="h-10 w-10 rounded-full" src="/assets/icons/currencies/color/{{crypto.baseCurrency | lowercase}}.svg" loading="lazy">
                      </div>
                      <div class="flex-1 min-w-0">
                        <a href="javascript:void(0);" (click)="selectCrypto(crypto)" class="focus:outline-none">
                          <!-- Extend touch target to entire panel -->
                          <span class="absolute inset-0" aria-hidden="true"></span>
                          <p class="text-sm font-medium text-gray-900">{{crypto.baseCurrency}} </p>
                          <p class="text-sm text-gray-500 truncate">{{crypto.baseCurrency | cryptosymbol2name | async}}</p>
                        </a>
                      </div>
                      <div>
                        {{crypto.price | formatmoney }}
                      </div>
                    </div>
                  </li>

                </ul>
              </div>
            </nav>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
